export default __webpack_public_path__ + "static/media/stewardship_commons_logo.c93e2e13.svg";